import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class AssetTypeService extends Service{
    constructor() {
        super();
        this.baseURL = 'assetType';
    }

    findByAssetCategoryId(assetCategoryId) {
        return fetch(SERVER_URL + this.baseURL +  '/findByAssetCategoryId'+ '/' + assetCategoryId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }
}